import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { Page } from '@/shared/models/page.model';
import { EleicaoPleito } from './eleicao-pleito.model';
import { EleicaoParticipacaoUf } from './eleicao-participacao-uf.model';
import { EleicaoTipoParticipacao, EleicaoVotante } from './eleicao-votante.model';

@Injectable({ providedIn: 'root' })
export class EleicaoService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    readonly PATH = SICOM_PATHS.eleicoes.base;

    consultarPleitos(context?: HttpContext): Observable<EleicaoPleito[]> {
        return this.http.get<EleicaoPleito[]>(`${this.PATH}/pleitos`, { context });
    }

    consultarParticipacao(pleito: number, uf?: string, context?: HttpContext): Observable<EleicaoParticipacaoUf[]> {
        return this.http.get<EleicaoParticipacaoUf[]>(`${this.PATH}/participacao`, this.criarOpcoes(context, { pleito, uf }));
    }

    consultarVotantes(pleito: number, uf: string | undefined, tipo: EleicaoTipoParticipacao, page?: number, size?: number, context?: HttpContext): Observable<Page<EleicaoVotante>> {
        return this.http.get<Page<EleicaoVotante>>(`${this.PATH}/participacao/votantes`, this.criarOpcoes(context, { pleito, uf, tipo, page, size }));
    }

    private criarOpcoes(context?: HttpContext, parametros: Record<string, string | number | null | undefined> = {}): { params?: HttpParams; context?: HttpContext } {
        let params = new HttpParams();

        Object.entries(parametros).forEach(([chave, valor]) => {
            if (valor !== null && valor !== undefined && valor !== '') {
                params = params.set(chave, String(valor));
            }
        });

        if (!params.keys().length) {
            return { context };
        }

        return { params, context };
    }
}
